import log from 'loglevel';
import { useEffect, useState } from 'react';
import { FirebaseModule } from '../../firebase';
import { useSite } from '../../sites';

export const useAppLoad = () => {
  const { load } = useSite();
  const [isLoaded, setIsLoaded] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      // Initialize Firebase.
      await FirebaseModule.initialize();

      // Extract URL params.
      const params = new URLSearchParams(window.location.search);
      const site = params.get('site');

      // Validate URL params.
      if (!site) {
        log.error('Site must be a valid ID');
        return;
      }

      // Load site from server.
      await load(site);

      setIsLoaded(true);
    })();
  }, [load]);

  return { isLoaded };
};
